var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('industry-head',{attrs:{"intro":_vm.data.intro,"enName":_vm.data.enName,"title":_vm.data.name}}),_c('industry-template-group',{attrs:{"subList":_vm.data.subList,"name":_vm.data.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }